import React from 'react'

function Provedores() {
  return (
    <div>Provedores</div>
  )
}

export default Provedores